<template>
  <div>
    <sms-mapping v-if="showConfig" @close-comp="toggleComp" />

    <template v-else>
      <!-- sms settings -->
      <b-modal
        id="modal-sms"
        cancel-variant="outline-secondary"
        hide-footer
        size="lg"
        centered
        title="SMS Settings"
        no-close-on-backdrop
      >
        <b-row>
          <b-col md="6">
            <b-form-group
              label="Title"
              invalid-feedback="Title is required"
              ref="title"
            >
              <b-form-input
                v-model.trim="myObj.title"
                placeholder="Enter title here"
                @input="CheckTitle"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Number"
              invalid-feedback="Number is required."
              ref="number"
            >
              <vue-tel-input
                v-model="myObj.number"
                :inputOptions="vueTelOptions"
                :dropdownOptions="dropOptions"
                :defaultCountry="$store.state.countryCode"
                @input="CheckNumber"
              ></vue-tel-input>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="API URL"
              invalid-feedback="API URL is required."
              ref="url"
            >
              <b-form-input
                v-model.trim="myObj.url"
                placeholder="Enter API URL here"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="API Key"
              invalid-feedback="API Key is required."
              ref="apikey"
            >
              <b-form-input
                v-model.trim="myObj.apiKey"
                placeholder="Enter API Key here"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="API Secret Key (Optional)"
              invalid-feedback="API Secret Key is optional."
              ref="apisecret"
            >
              <b-form-input
                v-model.trim="myObj.apiSecret"
                placeholder="Enter API Secret Key here"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" class="text-right">
            <b-button variant="success" @click="saveData()" :disabled="request">
              <b-spinner v-if="request" small type="grow" />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <b-card>
        <b-row class="mt-1">
          <b-col xl="2" lg="3" md="4" sm="12">
            <b-button @click="AddOpen()" block variant="primary">
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">Add Number</span>
            </b-button>
          </b-col>

          <b-col
            class="mt-lg-0 mt-md-0 mt-sm-1 mt-1 d-flex align-items-start"
            xl="10"
            lg="9"
            md="8"
            sm="12"
          >
            <b-form-group class="w-100">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>

                <b-form-input
                  v-model.trim="searchQuery"
                  placeholder="Search by title..."
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <!-- <b-button
              variant="outline-primary"
              class="btn-icon ml-50"
              v-b-tooltip.hover.top
              title="SMS Configuration"
              @click="toggleComp"
            >
              <feather-icon icon="SettingsIcon" />
            </b-button> -->
          </b-col>
        </b-row>

        <b-table
          class="mt-1"
          :items="filters"
          :fields="fields"
          :busy="dataLoading"
          show-empty
          responsive
          hover
        >
          <template #table-busy>
            <div class="d-flex justify-content-center mb-3 mt-3">
              <b-spinner
                style="width: 3rem; height: 3rem"
                type="grow"
                variant="primary"
                label="Spinning"
              ></b-spinner>
            </div>
          </template>
          <template #cell(title)="data">
            <b-badge variant="light-primary">
              {{ data.item.title }}
            </b-badge>
          </template>
          <template #cell(number)="data">
            <b-badge variant="light-primary">
              {{ data.item.number }}
            </b-badge>
          </template>
          <template #cell(status)="data">
            <!-- <b-badge
              :variant="
                data.item.status === 'active' ? 'light-success' : 'light-danger'
              "
            >
              {{ data.item.status }}
            </b-badge> -->
            <div class="d-flex align-items-center">
              <b-form-checkbox
                v-model="data.item.status"
                :value="'active'"
                :unchecked-value="'inactive'"
                switch
                @change="changeStatus(data.item, data.item.status === 'active')"
                :disabled="statusUpdating"
              />
            </div>
          </template>

          <template #head(actions)="data">
            <div class="text-center">
              <span>{{ data.label }}</span>
            </div>
          </template>

          <template #cell(actions)="data">
            <div class="text-center">
              <b-button
                variant="primary"
                v-b-tooltip.hover.left
                title="Edit"
                class="btn-icon mr-1"
                @click="EditOpen(data.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-card>
    </template>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BTable,
  BForm,
  BFormInput,
  BFormGroup,
  BInputGroupPrepend,
  BInputGroup,
  BSpinner,
  BPagination,
  BBadge,
  BFormCheckbox,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import SmsMapping from "./SmsMapping.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    SmsMapping,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BForm,
    BFormInput,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BSpinner,
    BPagination,
    BBadge,
    BFormCheckbox,
    vSelect,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      dataLoading: false,
      items: [],
      fields: [
        { key: "title", label: "Title" },
        { key: "number", label: "Number" },
        { key: "status", label: "Status" },
        { key: "actions", label: "Actions" },
      ],
      searchQuery: "",
      request: false,
      statusUpdating: false,
      myObj: {
        id: 0,
        title: "",
        url: "",
        number: "",
        apiKey: "",
        apiSecret: "",
        status: "active",
        campusID: this.$store.state.userData.cId,
      },
      vueTelOptions: { placeholder: "Enter contact number" },
      dropOptions: {
        disabled: false,
        showDialCodeInList: true,
        showFlags: true,
      },
      numError: false,
      showConfig: false,
    };
  },
  computed: {
    filters: function () {
      return this.items.filter((pro) => {
        return pro.title.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
  },
  created() {
    this.LoadData();
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    toggleComp() {
      this.showConfig = !this.showConfig;
    },
    async changeStatus(item, newStatus) {
      const result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: `Do you want to ${
          newStatus ? "activate" : "deactivate"
        } this setting?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });

      if (result.isConfirmed) {
        this.statusUpdating = true;
        let cObj = { ...item };
        cObj.status = newStatus ? "active" : "inactive";

        var status = await this.put({
          url:
            this.$store.state.domain +
            "SmsSettings/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          body: cObj,
          message: `Setting is now ${
            newStatus ? "active" : "inactive"
          } successfully!`,
          context: this,
          token: this.$store.state.userData.token,
        });
        this.statusUpdating = false;
        if (status) this.LoadData();
      } else {
        // Revert the toggle if user cancels
        item.status = newStatus ? "inactive" : "active";
      }
    },
    AddOpen() {
      this.myObj = {
        id: 0,
        title: "",
        url: "",
        number: "",
        apiKey: "",
        apiSecret: "",
        status: "active",
        campusID: this.$store.state.userData.cId,
      };
      this.$bvModal.show("modal-sms");

      setTimeout(() => {
        var elem = this.$refs["number"];
        console.log("elem", elem.state);
        elem.state = undefined;
        this.numError = false;
      }, 100);
    },
    EditOpen(obj) {
      this.myObj = { ...obj };
      this.$bvModal.show("modal-sms");
    },
    CheckTitle() {
      var elem = this.$refs["title"];
      if (!this.myObj.title) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckUrl() {
      var elem = this.$refs["url"];
      if (!this.myObj.url) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckNumber(s, e) {
      //   console.log("e", e);
      var elem = this.$refs["number"];
      if (this.myObj.number) {
        if (e.valid) {
          this.numError = false;
          this.myObj.number = e.number;
        } else {
          this.numError = true;
        }
      } else {
        this.numError = true;
      }
      return (elem.state = !this.numError);
    },
    CheckApiKey() {
      var elem = this.$refs["apikey"];
      if (!this.myObj.apiKey) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveData() {
      if (!this.myObj.number) this.numError = true;
      let s1 = this.CheckTitle();
      let s2 = this.CheckUrl();
      let s3 = !this.myObj.number || this.numError == true;
      let s4 = this.CheckApiKey();

      if (!s1 || !s2 || s3 || !s4) {
        return this.$bvToast.toast("Please fill the details correctly.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.request = true;
        if (this.myObj.id == 0) {
          var status = await this.post({
            url:
              this.$store.state.domain +
              "SmsSettings?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Setting added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          var status = await this.put({
            url:
              this.$store.state.domain +
              "SmsSettings/" +
              this.myObj.id +
              "?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: "Setting updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        }
        this.request = false;
        if (status) {
          this.LoadData();
          this.$bvModal.hide("modal-sms");
        }
      }
    },

    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "SmsSettings?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);
      this.dataLoading = false;
    },
  },
};
</script>
<style></style>
